<template>
  <CCard class="mb-3">
    <CCardHeader>Rendimiento por dia</CCardHeader>
    <CCardBody>
      <apexchart
        type="bar"
        height="300"
        :options="chartOptions"
        :series="chartSeries"
      />
    </CCardBody>
  </CCard>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'WeekdayPerformanceChart',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    categories() {
      return this.rows.map(function (row) {
        return row.weekday_label || 'N/D'
      })
    },
    readValues() {
      return this.rows.map(function (row) {
        return Number(row && row.read_rate ? row.read_rate : 0) * 100
      })
    },
    responseValues() {
      return this.rows.map(function (row) {
        return Number(row && row.response_rate ? row.response_rate : 0) * 100
      })
    },
    chartSeries() {
      return [
        { name: 'Lectura', data: this.readValues },
        { name: 'Respuesta', data: this.responseValues },
      ]
    },
    chartOptions() {
      return {
        chart: {
          stacked: false,
          toolbar: { show: false },
          foreColor: '#5c5648',
        },
        colors: ['#8AA1B1', '#B59B6A'],
        dataLabels: { enabled: false },
        plotOptions: {
          bar: {
            borderRadius: 4,
            columnWidth: '60%',
          },
        },
        xaxis: {
          categories: this.categories,
        },
        yaxis: {
          max: 100,
          labels: {
            formatter: function (value) {
              return value.toFixed(0) + '%'
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value.toFixed(1) + '%'
            },
          },
        },
        grid: {
          borderColor: '#ece7d8',
        },
        legend: {
          position: 'top',
        },
      }
    },
  },
}
</script>
